import React, { Fragment, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { Popconfirm } from "antd";
import {
  faPen,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";

import { requestGetStoriesList } from "./requests/getStories";
import { addStories } from "./requests/addStories";
import { deleteStories } from "./requests/deleteStories";
import useSearchHook from "../../../hooks/useSearch.hook";
import Filters from "./filters";

const Stories = (props) => {
  const [loading, setLoading] = useState(true);
  const [pageItems, setPageItems] = useState([]);
  const {
    getList,
  } = props;

  const {
    page,
    size,
    sort,
    filters,
    handleSortedChange,
  } = useSearchHook(getList, {
    size: 1000,
    sort: "date,desc",
    callback: setPageItems,
    setLoading,
  });

  const reload = () => {
    getList(page, size, sort, filters, setPageItems, setLoading);
  };

  const handleDelete = (id) => {
    setLoading(true);
    deleteStories(id)
      .then(() => {
        toast("Story removed successfully", {
          type: toast.TYPE.SUCCESS,
        });
        reload();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChangeOrder = async (original, value) => {
    const newOrder = Number(value);
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(newOrder) && newOrder !== original.order) {
      await addStories({
        ...original,
        order: newOrder
      });
      reload();
    }
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Order",
      accessor: "order",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className="d-flex">
          <input
            className="form-control form-control-sm"
            defaultValue={original.order}
            min={0}
            type="number"
            onBlur={async (event) => {
              await handleChangeOrder(original, event.target.value);
            }}/>
        </div>
      )
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Country",
      accessor: "country",
    },
    {
      Header: "Pages",
      accessor: "pages",
      Cell: ({ original }) => original.pages.length,
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Fragment>

          <Link
            className="btn btn-sm btn-primary mx-2"
            to={`/stories/${original.id}/0`}
          >
            <FontAwesomeIcon icon={faPen}/>
          </Link>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger mx-2">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </Fragment>
      ),
    }
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          activeFilters={[]}
          totalCount={false}
        />
      </div>
      <ReactTable
        data={pageItems || []}
        headerClassName="table-header"
        columns={getColumns()}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        showPagination={false}
      />
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(requestGetStoriesList, dispatch),
});

export default connect(
  null,
  mapStateToDispatch
)(Stories);



// WEBPACK FOOTER //
// ./src/views/pages/stories/index.js